import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M8.93333 19L8 18.0755L14.1333 12L8 5.92453L8.93333 5L16 12L8.93333 19Z" />
    </Icons>
  );
}
